class DestroyOnHit {}

export default DestroyOnHit;
